import { useState } from "react";
import "./styles.scss";

import { Button, Form, Input, notification } from "antd";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

import Logo from "../../assets/images/logo-dark.png";
import { API } from "../../config/Api";
import { login } from "../../redux/slice/userSlice";
import { POST } from "../../utils/apiRequest";

function LoginScreen() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const onFinish = async (values: any) => {
    try {
      setLoading(true);
      let obj = {
        email: values.user,
        password: values.password,
      };
      let url = API.LOGIN;
      let { data, status, message }: any = await POST(url, obj);
      if (status) {
        
        setLoading(false);
        // if (data?.office.status === true && data?.user?.status === true) {

        if (data?.office) {
          notification.success({ message });
          dispatch(login({ ...data }));
          navigate("/Auth");
        } else {
          navigate("/lockScreen");
        }
      } else {
        setLoading(false);
        notification.error({ message });
      }
    } catch (error) {
      setLoading(false);
      console.error("Login failed:", error);
    }
  };

  return (
    <div>
      <Container>
        <div className="loginScreen">
          <Row>
            <Col sm={4}></Col>
            <Col sm={4}>
              <div className="loginScreen-Box3">
                <img src={Logo} alt="" />
              </div>
              <br />
              <div className="loginScreen-txt1">Login and Continue</div>
              <Form onFinish={onFinish}>
                <label className="formLabel">Email or Username</label>
                <Form.Item
                  name={"user"}
                  rules={[{ required: true, message: "Required" }]}
                >
                  <Input />
                </Form.Item>
                <label className="formLabel">Password</label>
                <Form.Item
                  name={"password"}
                  rules={[{ required: true, message: "Required" }]}
                >
                  <Input.Password />
                </Form.Item>
                <br />
                <Button
                  block
                  htmlType="submit"
                  type="primary"
                  loading={loading}
                >
                  Sign In
                </Button>
              </Form>
            </Col>
            <Col sm={4}></Col>
          </Row>
        </div>
      </Container>
    </div>
  );
}

export default LoginScreen;
